module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"LoginForm":{"button":"Přihlásit","email":"E-mail","linkPasswordForgotten":"Zapomněli jste heslo?","password":"Heslo","registerLink":{"link":"Registrujte se.","text":"Ještě nemáte účet?"},"title":"Přihlášení","vv-email":"e-mail","vv-password":"heslo"}},"en":{}}')
  delete Component.options._Ctor
}
